export const rupee = (n) => `\u20B9${Number(n || 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
export const r2 = (x) => Math.round((Number(x || 0) + 1e-9) * 100) / 100;
export const uid = () => (globalThis.crypto?.randomUUID ? globalThis.crypto.randomUUID() : `it-${Math.random().toString(36).slice(2)}`);
